import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ReportService {

  constructor(
    private http: HttpClient
  ) { }

  generateReport() {
    return this.http.get(`${environment.apiUrl}/globalvision/report/generate`, {
      headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '')
    })
  }

}